import { useUrlParam } from "@opendash/core";
import Parse from "parse";
import React, { useEffect, useMemo } from "react";
import { Project } from "../../../../js/parsegenerated";
import { useProjects } from "./useProjects";

export type Filters = {
  filterUser?: any;
  showFinished?: any;
  search?: any;
};

export const useProjectFilter = () => {
  // projects that are filtered but not searched
  const [filteredOnlyProjects, setFilteredOnlyProjects] = React.useState<
    Project[]
  >([]);
  const [filters, setFilter] = useUrlParam<Filters>("filters", {});
  const { projects } = useProjects(undefined, filters?.showFinished);

  const rootProjects = useMemo(
    () => projects.filter((p) => !p.parent),
    [projects]
  );

  function setFilterValue(key: keyof Filters, value: any) {
    const newFilters = { ...filters };
    newFilters[key] = value;
    setFilter(newFilters);
  }

  useEffect(() => {
    filterProjects();
  }, [projects, filters.filterUser]);

  async function filterProjects() {
    const filteredProjectList: Project[] = [];
    if (filters.filterUser) {
      for (const project of projects) {
        const found = await project
          .get("assignedUsers")
          .query()
          .equalTo("objectId", Parse.User.current().id)
          .count();

        if (found) filteredProjectList.push(project);
      }
    }
    setFilteredOnlyProjects(filteredProjectList);
  }

  // Filtered projects where also the search is applied
  const filteredProjects = useMemo(() => {
    const searchArray = filters.filterUser ? filteredOnlyProjects : projects;
    if (!filters?.search) return searchArray;
    const filtered = searchArray.filter((project) =>
      project.get("name").toLowerCase().includes(filters?.search?.toLowerCase())
    );

    return filtered;
  }, [
    filteredOnlyProjects,
    filters.search,
    filters.filterUser,
    filters.showFinished,
    projects,
  ]);

  return {
    allProjects: projects,
    filteredProjects,
    rootProjects,
    filters,
    setFilter: setFilterValue,
    areFiltersEmpty: Object.keys(filters).length === 0,
  };
};
